exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "ol.numbered[data-v-5ac8f923] {\n  margin-left: 1.2em;\n}\nol.numbered > li[data-v-5ac8f923] {\n  list-style: decimal;\n}\n.center-text[data-v-5ac8f923] {\n  text-align: center;\n}\n.right-text[data-v-5ac8f923] {\n  text-align: right;\n}", ""]);

// exports
